var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXai(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 18 18",
    fill: "black",
    className: "fill-black dark:fill-white size-4 flex-none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0898 5.7984L14.4005 18.0004H16.889L17.2001 1.35645L14.0898 5.7984Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2007 0H13.4037L7.44531 8.51004L9.34383 11.2214L17.2007 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.799805 18.0001H4.59683L6.49572 15.2888L4.59683 12.5771L0.799805 18.0001Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.799805 5.79785L9.34349 17.9999H13.1405L4.59683 5.79785H0.799805Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXai);
export default __webpack_public_path__ + "static/media/xai.8892a51105e546189e86c7fa509226d6.svg";
export { ForwardRef as ReactComponent };